import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { Button } from '@systemzero-inc/ui/primitives/button';

export function Auth0ErrorSection() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { logout } = useAuth0();

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  const hasError = error && errorDescription;

  return (
    <section className="bg-background py-16 lg:py-24" aria-labelledby="error-title">
      <div className="container px-6 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 relative z-10 mx-auto">
        <div className="flex flex-col gap-6 lg:gap-8 flex-1 max-w-xl items-center text-center m-auto">
          <div className="flex flex-col gap-4 lg:gap-5">
            <p className="text-muted-foreground text-sm lg:text-base font-semibold" aria-label="Error code">
              {hasError ? t('error.invalid_request') : t('error.404.code')}
            </p>
            <h1 id="error-title" className="text-foreground text-3xl md:text-5xl font-bold">
              {hasError ? t('error.title') : t('error.404.title')}
            </h1>
            <p className="text-muted-foreground text-base lg:text-lg">
              {errorDescription ?? t('error.404.description')}
            </p>
          </div>
          <Button onClick={() => logout({ logoutParams: { returnTo: import.meta.env.VITE_APP_URL } })}>
            {t('error.goToLogin')}
          </Button>
        </div>
      </div>
    </section>
  );
}
